import { WithServiceId } from '@mews-commander/types';
import { useResolveRoute } from '@mews/routing';
import { ArticlePath, createGuideLink, RouteName } from '@mews-commander/enums';
import { LocalizedProperty, lt } from '@mews/framework';
import { OptimusProvider } from '@mews-commander/ui';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { getEnterpriseName } from '@mews-commander/legacy-entities/src/ducks/enterprises';
import { getServiceNames } from '@mews-commander/legacy-entities/src/ducks/services';
import { useCommanderSelector } from '@mews-commander/utils';
import { BaseLayout } from '../../../components/layout';
import { Breadcrumbs } from '../../../components/BreadcrumbList';
import { RateGroupTable } from '../components';
import { CurrentServiceIdContextProvider } from '../contexts';
import { RateGroupSidePanelContextProvider } from '../components/sidePanel/RateGroupSidePanelContext';

export const RateGroupListView = ({ serviceId }: WithServiceId) => {
    const resolveRoute = useResolveRoute();
    const enterpriseId = useCurrentEnterpriseId();

    const enterpriseUrl = resolveRoute(RouteName.EnterpriseDetail, { enterpriseId });
    const enterpriseName = useCommanderSelector((state) => getEnterpriseName(state, { enterpriseId }));

    const serviceListUrl = resolveRoute(RouteName.ServiceIndex, { query: { OwnerId: enterpriseId } });

    const serviceNames = useCommanderSelector((state) => getServiceNames(state, { id: serviceId }));
    const serviceUrl = resolveRoute(RouteName.VisitDetail, { serviceId });

    const breadcrumbs: Breadcrumbs = [
        {
            text: enterpriseName,
            url: enterpriseUrl,
        },
        {
            text: lt('ServicePlural'),
            url: serviceListUrl,
        },
        {
            text: serviceNames ? <LocalizedProperty property={serviceNames} /> : lt('Service'),
            url: serviceUrl,
        },
        {
            text: lt('RateGroupPlural'),
            active: true,
        },
    ];

    return (
        <CurrentServiceIdContextProvider value={serviceId}>
            <OptimusProvider density="spacious">
                <BaseLayout
                    breadcrumbs={breadcrumbs}
                    guideLink={createGuideLink(ArticlePath.CreateModifyDeleteRateGroup)}
                    padded
                >
                    <RateGroupSidePanelContextProvider>
                        <RateGroupTable serviceId={serviceId} />
                    </RateGroupSidePanelContextProvider>
                </BaseLayout>
            </OptimusProvider>
        </CurrentServiceIdContextProvider>
    );
};
